import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
} from '@angular/core';

@Component({ standalone: true, 
  selector: 'cyborg-notification',
  imports: [CommonModule],
  templateUrl: './cyborg-notification.component.html',
  styleUrls: ['./cyborg-notification.component.scss'],
})
export class CyborgNotificationComponent {
  @Output() public onClick = new EventEmitter<MouseEvent>();
  @Input() public color: 'warning' | 'error' | 'success' | 'info';

  @HostBinding('class.warning')
  public get warning(): boolean {
    return this.color == 'warning';
  }

  @HostBinding('class.error')
  public get error(): boolean {
    return this.color == 'error';
  }

  @HostBinding('class.success')
  public get success(): boolean {
    return this.color == 'success';
  }

  @HostBinding('class.info')
  public get info(): boolean {
    return this.color == 'info';
  }

  public onClickButton(event): void {
    this.onClick.emit(event);
  }
}
